import { Injectable } from '@nestjs/common'
import { HealthIndicatorResult, HealthIndicatorService } from '@nestjs/terminus'

@Injectable()
export class AppHealthIndicator {
	constructor(private readonly healthIndicatorService: HealthIndicatorService) {}

	async pingCheck(key: string): Promise<HealthIndicatorResult> {
		const indicator = this.healthIndicatorService.check(key)
		return indicator.up()
	}
}
